import HttpClient from 'services/api';
import { ENDPOINTS } from 'services/api/endpoints';

// Registra um evento do usuário mapeando as interações dele na aplicação
const createEvent = (payload) => HttpClient.post(ENDPOINTS.TRACKING, payload);

export const createEventTracking = async (event) => {
  try {
    await createEvent({ event });
  } catch (error) {
    console.log(error);
  }
};
